import { render, staticRenderFns } from "./Startup.vue?vue&type=template&id=2fe250ed&"
import script from "./Startup.vue?vue&type=script&lang=js&"
export * from "./Startup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports